import { httpMobile } from "@/utils/httpMobile"


//商品标签  http://api.newdhb.com/api.php?c=GoodsManager&a=goodsScreening
export interface GoodsTagsBrand {
  "code": string // "100",
  "message": string // "",
  "action_time": number // 1721716776,
  "data": {
    "tags": Array<{
      "tags_id": string // "1",
      "tags_name": string // "新品"
    }>,
    "stock": {
      "count": string // "97",
      "list": Array<{
        "stock_id": string // "284",
        "stock_name": string // "默认仓库"
      }>
    },
    "brand": {
      "count": string // "111",
      "list": Array<{
        "brand_id": string // "24569",
        "brand_name": string // "MMM&lsquo;/MMM"
      }>
    }
  }
}


export const serviceFilterGoodsTagAndBrand = async  () => {
  return  httpMobile.post<GoodsTagsBrand>(`/api.php`,{
    a:'goodsScreening',
    c:"GoodsManager"
  })
}